import {colorCodes} from 'definitions/constant'
/* eslint-disable @typescript-eslint/no-explicit-any */
const fontColorCheck = (isSelected: boolean, isFocused: boolean) => {
  if (isSelected && isFocused) return '#00AEEA'
  return isSelected ? '#00AEEA' : '#fff'
}

// eslint-disable-next-line
const menuList = (base: any, background: string = colorCodes.gray900) => ({
  ...base,
  padding: 0,
  background: `${background} !important`,
})

// eslint-disable-next-line
const option = (
  styles: any,
  {isFocused, isSelected}: any,
  backgroundColor: string = colorCodes.dopeBlack,
  hoverColor: string = colorCodes.dopeGray1500,
) => ({
  ...styles,
  background: isFocused ? hoverColor : backgroundColor,
  color: fontColorCheck(isSelected, isFocused),
  zIndex: 1,
  '&:active': {
    background: `${hoverColor} !important`,
  },
})

export const customDropDownStyles = {
  // eslint-disable-next-line
  control: (base: any) => ({
    ...base,
    border: 'none !important',
    borderRadius: '0 !important',
    boxShadow: '0 !important',
    background: 'transparent !important',
    fontSize: 12,
    textTransform: 'capitalize',
  }),
  // eslint-disable-next-line
  menu: (base: any) => ({
    ...base,
    borderRadius: 0,
    background: `${colorCodes.dopeBlack} !important`,
    borderLeft: `1px solid ${colorCodes.white} !important`,
    borderRight: `1px solid ${colorCodes.white} !important`,
    borderBottom: `1px solid ${colorCodes.white} !important`,
    fontSize: 12,
    textTransform: 'capitalize',
    marginTop: 1,
    width: 150,
    right: 0,
  }),
  menuList,
  option,

  // eslint-disable-next-line
  singleValue: (base: any) => ({
    ...base,
    color: '#fff',
  }),
  // eslint-disable-next-line
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#fff',
  }),
}

export const customDropDownExceptionStyles = {
  // eslint-disable-next-line
  control: (base: any) => ({
    ...base,
    border: 'none !important',
    borderRadius: '0 !important',
    boxShadow: '0 !important',
    background: 'transparent !important',
    fontSize: 12,
  }),
  // eslint-disable-next-line
  menu: (base: any) => ({
    ...base,
    borderRadius: 0,
    background: `${colorCodes.dopeBlack} !important`,
    border: `1px solid ${colorCodes.white} !important`,
    borderTopColor: 'transparent !important',
    fontSize: 12,
    marginTop: 0.5,
  }),
  menuList,
  option,

  // eslint-disable-next-line
  singleValue: (base: any) => ({
    ...base,
    color: '#fff',
  }),
  // eslint-disable-next-line
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#fff',
    display: 'none',
  }),
  input: (base: any) => ({
    ...base,
    color: '#fff',
  }),
  group: (base: any) => ({
    ...base,
    padding: 0,
  }),
  groupHeading: (base: any) => ({
    ...base,
    padding: '8px 12px',
  }),
}

export const customDropDownStyles_2 = {
  // eslint-disable-next-line
  control: (base: any) => ({
    ...base,
    border: '1px solid #6c6c6c !important',
    borderRadius: '0 !important',
    boxShadow: '0 !important',
    background: 'transparent !important',
    fontSize: 12,
  }),
  // eslint-disable-next-line
  menu: (base: any) => ({
    ...base,
    borderRadius: 0,
    marginTop: -1,
    background: `${colorCodes.dopeBlack} !important`,
    border: '1px solid #6c6c6c !important',
    borderTopColor: 'transparent !important',
    fontSize: 12,
  }),
  menuList,
  option,

  // eslint-disable-next-line
  singleValue: (base: any) => ({
    ...base,
    color: '#fff',
  }),
  // eslint-disable-next-line
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#999', // Custom colour
  }),
  group: (base: any) => ({
    ...base,
    padding: 0,
  }),
  groupHeading: (base: any) => ({
    ...base,
    padding: '8px 12px',
  }),
}

export const customDropDownStyles_3 = {
  // eslint-disable-next-line
  control: (base: any) => ({
    ...base,
    border: '1px solid #6c6c6c !important',
    borderRadius: '0 !important',
    boxShadow: '0 !important',
    background: 'transparent !important',
    fontSize: 12,
  }),
  // eslint-disable-next-line
  menu: (base: any) => ({
    ...base,
    borderRadius: 0,
    marginTop: -13,
    background: `${colorCodes.dopeBlack} !important`,
    border: '1px solid #6c6c6c !important',
    borderTopColor: 'transparent !important',
    fontSize: 12,
  }),
  // eslint-disable-next-line
  menuList: (base: any) => ({
    ...base,
    padding: 0,
    background: '#151515 !important',
  }),

  // eslint-disable-next-line
  option: (styles: any, {isFocused, isSelected}: any) => ({
    ...styles,
    background: isFocused ? '#333' : colorCodes.dopeBlack,
    color: isSelected ? '#00AEEA' : '#fff',
    zIndex: 1,
  }),
  // eslint-disable-next-line
  singleValue: (base: any) => ({
    ...base,
    color: '#999',
  }),
  // eslint-disable-next-line
  dropdownIndicator: (base: any) => ({
    ...base,
    color: '#999', // Custom colour
  }),
}
